<div class="item-card p-3 h-100 d-flex flex-column"
     [ngClass]="isAtivo ? 'card-status-ativo' : 'card-status-pendente'">

  <div class="d-flex align-items-center mb-2">
    <em class="{{ icon }} mr-2 box-icon"></em>
    <p class="box-title">{{ title }}</p>
  </div>

  <p class="text-muted box-description">{{ description }}</p>

  <div class="d-flex align-items-center justify-content-between mt-auto">
    <span class="badge px-2 py-1 badge-status"
          [ngClass]="isAtivo ? 'badge-success' : 'badge-warning'">
      <em class="mr-1"
          [ngClass]="isAtivo ? 'fas fa-check-circle' : 'fas fa-clock'"></em>
      {{ isAtivo ? 'Ativo' : 'Pendente' }}
    </span>

    <button
      *ngIf="actionEnabled"
      type="button"
      class="btn btn-sm btn-outline-secondary"
      [disabled]="!actionEnabled || loading"
      (click)="clickButtonAction.emit()"
      [ngClass]="loading ? 'button-isloading' : ''"
      >
      <span *ngIf="loading" >
        <em class="fas fa-circle-notch fa-spin mr-1"></em>
      </span>
      {{ loading ? 'Atualizando...' : 'Atualizar' }}
    </button>
  </div>

</div>
